/**
 * Created by Alex Aguilar on 9/7/2016.
 */
(function(){
    'use strict';

    var asideNavbar = {
        templateUrl: 'app/components/asideNavbar/asideNavbar.html',
        controller: asideNavbarController,
        controllerAs: 'vm'
    };

    angular
        .module('completeAir')
        .component('asideNavbar', asideNavbar);

    asideNavbarController.$inject = ['$rootScope', '$state', '$timeout']

    function asideNavbarController($rootScope, $state, $timeout){
        var vm = this;

        vm.$onInit = function () {
            vm.showMenu = '';
            vm.accessesMenu = [];
        }

        vm.goRoute = function (route, name , targetId, type) {
            var eleJQAsideNavbar = $('#sidebar-menu');
            var eleJQ = $('#' + targetId);
            var eleJQLi = eleJQ.parent();

            if(type === 1) {
                vm.removeClassLi(eleJQAsideNavbar);
                eleJQLi.addClass('active');
                vm.showMenu = name;
            }else {
                var eleJQUl = eleJQ.closest(".level-1");
                vm.removeClassLi2(eleJQUl);
                eleJQLi.addClass("sub-title-active");
                vm.showMenu = name;
            }

            $state.go(route, null, { reload: true });
        }

        vm.goRouteParent = function (route, name, targetId) {
            var eleJQAsideNavbar = $('#sidebar-menu');
            var eleJQ = $('#' + targetId);
            var eleJQLi = eleJQ.parent();

            vm.removeClassLi(eleJQAsideNavbar);
            eleJQLi.addClass('in active');
            vm.showMenu = name;
        }

        vm.collapseLevel = function($event, level){
            var eleJQ = $($event.currentTarget),
                eleJQLi = eleJQ.parent(),
                eleJQUl = eleJQ.next(),
                expandCollapse = eleJQ.data("collapse");

            var eleJQAsideNavbar = eleJQ.closest(".aside-navbar");

            switch (expandCollapse){
                case "show":
                    vm.removeClassLi(eleJQAsideNavbar);
                    eleJQ.data("collapse", "hide");
                    eleJQLi.addClass("in active");
                    eleJQUl.addClass("collapse in");
                    break;
                case "hide":
                    eleJQ.data("collapse", "show");
                    eleJQLi.removeClass("in active");
                    eleJQUl.removeClass("collapse in");
                    break;
            }
        }

        vm.collapseLevel2 = function($event, level){
            var eleJQ = $($event.currentTarget),
                eleJQLi = eleJQ.parent(),
                eleJQUl = eleJQ.closest(".level-1");
            vm.removeClassLi2(eleJQUl);
            eleJQLi.addClass("sub-title-active");
        }

        vm.removeClassLi2 = function(eleJQUl){
            eleJQUl.find(" > li").each(function(){
                var eleJQ = $(this);
                eleJQ.removeClass("sub-title-active");
            })
        }

        vm.removeClassLi = function(eleJQAsideNavbar, id){
            eleJQAsideNavbar.find(" > li").each(function(){
                var eleJQ = $(this);
                eleJQ.removeClass("in active");
                eleJQ.find(" > a").data("collapse", "show");
                eleJQ.find(" > ul").removeClass("collapse in");
                vm.removeClassLi2(eleJQ.find(" > ul"));
            })
        }

        $rootScope.$on('navbar', function (event, data) {
            vm.accessesMenu = [];
            vm.accessesMenu = data;
        });
    }
})();
